module.exports = __webpack_public_path__ + "a8a10a3e/img/share-action-icon.9c12578c.svg";